import { Theme } from '@mui/material/styles'

// ==============================|| OVERRIDES - ALERT TITLE ||============================== //

export default function Chip(theme: Theme) {
  return {
    MuiChip: {
      defaultProps: {},
      styleOverrides: {
        root: {
          padding: '2px 10px',
          borderRadius: '8px',
          borderColor: theme.palette.primary.light,
          gap: '4px',
          '& .MuiChip-icon': {
            marginLeft: 0,
            marginRight: 0,
          },
        },
        label: {
          padding: '0px',
          fontSize: '14px',
          lineHeight: '20px',
        },
      },
    },
  }
}
